module.exports = __webpack_public_path__ + "img/about_us_bg.ee96607.png";